import React, { useEffect, useState } from 'react';
import {
  getSalvageyLogoUrl,
  SALVAGEY_LOGO_SOURCE,
  uploadSalvageyLogo
} from '../../services/branding';

export const BrandLogo = ({ className = '' }) => {
  const [logoUrl, setLogoUrl] = useState(SALVAGEY_LOGO_SOURCE);

  useEffect(() => {
    let isMounted = true;

    const loadStoredLogo = async () => {
      const storedLogoUrl = await uploadSalvageyLogo();

      if (isMounted) {
        setLogoUrl(storedLogoUrl || getSalvageyLogoUrl());
      }
    };

    loadStoredLogo();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <img
      src={logoUrl}
      alt="Salvagey"
      className={`object-contain ${className}`}
      onError={(event) => {
        event.currentTarget.src = SALVAGEY_LOGO_SOURCE;
      }}
    />
  );
};